/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class SecondCusOrder extends React.Component {
  render() {
    return <div className='dms-body'>
      {this.props.children}
    </div>
  }
};
export default SecondCusOrder;


// WEBPACK FOOTER //
// ./src/routes/secCusOrder/index.js